import { FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useOrgunitListData } from "../../Onboarding/hooks/useOnBoard";

import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import PageHeader from "../../../Component/BasicComponents/HeaderBreadCrumbs";
import { useState } from "react";

const OnboardingRequestDataColumns = (handleViewClick: (row: any) => void) => [
  {
    name: "Organization Unit",
    selector: (row: { UnitName: string }) => row.UnitName || "-",
    sortable: true,
  },
  {
    name: "Action",
    width: "200px",
    cell: (row: any) => (
      <div className="d-flex align-items-center gap-2">
        <button
          className="btn d-flex align-items-center justify-content-center gap-1"
          onClick={() => handleViewClick(row)}
          style={{
            backgroundColor: "#2e8dd3",
            color: "white",
            borderRadius: "20px",
            padding: "3px",
            width: "70px",
            border: "none",
          }}
        >
          <FaEye size={14} style={{ fill: "#fff" }} /> View
        </button>
      </div>
    ),
  },
];

const CustomerOrgList = () => {
  const [pageState, setPageState] = useState({
    page: 1,
  });
  const [limitState, setLimitState] = useState({
    limit: 10,
  });
  const [search, setSearch] = useState({
    searchValue: "",
  });
  const navigate = useNavigate();
  const handleViewClick = (row: any) => {
    // console.log("ROW:::::::::::::", row);
    navigate(`/customer/CustomerList`, {
      state: { orgunitId: row },
    });
  };
  const { data: orgUnitsData, isLoading: orgunitLoading } = useOrgunitListData({
    enable: true,
    params: {
      page: pageState.page,
      search: search.searchValue,
      limit: limitState.limit,
    },
  });

  console.log(
    "🚀 ~ OnboardingRequest.tsx:45 ~ OnboardingRequest ~ orgUnitsData:",
    orgUnitsData?.data
  );

  const formattedTableData = Object.entries(orgUnitsData?.data || {}).map(
    (item: any, index: any) => ({
      OrgunitId: item[0],
      OrgunitNames: item[1],
    })
  );

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
    setLimitState((prevState: any) => {
      return {
        ...prevState,
        limit: limit,
      };
    });
  };
  const handlePagination = (pageNo: number) => {
    setPageState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };

  const handleSearch = (searchValue: any) => {
    setSearch((prevState: any) => {
      return {
        ...prevState,
        searchValue,
      };
    });
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Customer Org List"
        // buttons={[
        //   {
        //     label: "Import",
        //     onClick: () => alert("Action 3 clicked"),
        //     color: "#43B9B2",
        //   },
        //   {
        //     label: "Excel",
        //     onClick: () => alert("Action 4 clicked"),
        //     color: "#43B9B2",
        //   },
        // ]}
      />
      <BasicDataTable
        Title="Org List"
        columns={OnboardingRequestDataColumns(handleViewClick)}
        showSpinner={orgunitLoading}
        data={orgUnitsData?.data || []}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
      />
    </div>
  );
};

export default CustomerOrgList;
